const InfiniteScroll = require('infinite-scroll');

const infContainer = document.querySelector('.js-infinite-container');

function reloadSrcsetImgs(item) {
  const imgs = item.querySelectorAll('img[srcset]');
  for (let i = 0; i < imgs.length; i += 1) {
    const img = imgs[i];
    img.outerHTML = img.outerHTML;
  }
}

function infiniteContent() {
  if (infContainer) {
    // eslint-disable-next-line no-unused-vars
    const infScroll = new InfiniteScroll(infContainer, {
      path: '.js-infinite-target',
      append: '.c-tease',
      history: false,
      hideNav: '.js-infinite-target',
    });

    infScroll.on('append', (response, path, items) => {
      for (let i = 0; i < items.length; i += 1) {
        reloadSrcsetImgs(items[i]);
      }
    });
  }
}

export default infiniteContent;



// WEBPACK FOOTER //
// ./src/scripts/modules/infinite-content.js